
import LeadContent from "pages/shared/lead-content/LeadContent"
import Loading from "pages/shared/loading/Loading"
import { useContext, useEffect, useState } from "react"
import { useErrorBoundary } from "react-error-boundary"
import { useNavigate, useParams } from "react-router"
import { NotificationContext } from "shared/NotificationContext"
import backofficeApi from 'shared/topchef-api-backoffice';
import { Lead, NotificationType } from "shared/topchef.types"

const AllLeadDetails = () => {

  const navigate = useNavigate();
  
  const notificationContext = useContext(NotificationContext);
  const { triggerNotification } = notificationContext;

  const params = useParams();
  const leadId: string = params.leadId || '';

  const [isReady, setReady] = useState<boolean>(false);
  const [lead, setLead] = useState<Lead | null>(null);

  const { showBoundary } = useErrorBoundary();

  useEffect(() => {

    async function loadLead() {
      try {
        const lead: Lead = await backofficeApi.loadLeadDetails(leadId);
        setLead(lead);
        setReady(true);
      } catch (error: any) { 
        const newError = new Error(`Problème pour récupérer le brief : '${error.message}'`);
        triggerNotification({type: NotificationType.error, message : newError.message}); 
        showBoundary(newError);
      } 
    }

    if (isReady) {
      return;
    }

    loadLead();

  }, [isReady, leadId, showBoundary, triggerNotification]);


  const backToAllLeads = async () => {
    navigate('/backoffice/leads/all');
  };


  if (!isReady) {
    return (
      <Loading />
    );
  }

  
  return (
    <div className="container p-2 col-md-6 overflow-auto">
       
      <LeadContent lead={lead!} />

      <div className="text-center">
        <div className="text-center btn-list">
            <button className="btn btn-primary m-3" onClick={backToAllLeads}>Retour aux briefs</button> 
        </div>
      </div>

    </div>
  );

}

export default AllLeadDetails;
